import React from 'react'
import PlatButton from 'components/presenter/buttons/PlatButton'
// import LampOn from 'assets/icon/idea-on.svg'
// import LampOff from 'assets/icon/idea-off.svg'
import cn from 'classnames'
import * as styles from './header.module.css'

const Header = ({isLampOn, onLampClick}) => {
  const lampCmp = <></>
  // isLampOn ? <LampOn className={styles.lampIcon} /> : <LampOff className={styles.lampIcon} />
  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.headerBar}>
          <h3 className={styles.headerTitle}>App</h3>
          <PlatButton>合作伙伴</PlatButton>
          <PlatButton>留言</PlatButton>
          <PlatButton>購買</PlatButton>
        </div>
        <div className={styles.lampContainer}>
          <div className={styles.lamp}>
            <button type="button" className={cn(!isLampOn ? 'svgFill' : '', 'buttonIcon')} onClick={onLampClick}>
              {lampCmp}
            </button>
            <div 
              className={cn('buttonIcon', styles.lampTail)} 
              onClick={onLampClick} 
              onKeyDown={onLampClick} 
              role="button"
              tabIndex={0} 
            />
          </div>
        </div>
      </div>
    </header>
  )
}
export default Header